import type { DiscountCalculator } from './DiscountCalculator';
import type { DiscountFixedAmount } from '@/modules/store/models/Discount';
import type { Amount, CalculatedPrice, Price } from '@/modules/store/models/Price';
import { roundPayableAmount, roundUnitPrice } from '@/utils/currency/roundPrice';

export class FixedAmountDiscountCalculator implements DiscountCalculator<DiscountFixedAmount> {
  isApplicable(quantity: number, discount: DiscountFixedAmount): boolean {
    return (
      (!discount.quantityFrom || quantity >= discount.quantityFrom) &&
      (!discount.quantityTo || quantity <= discount.quantityTo)
    );
  }

  calculate(
    originalPrice: Price,
    quantity: number,
    discount: DiscountFixedAmount,
  ): CalculatedPrice {
    const originalAmount = originalPrice.price;
    const unitPrice = roundUnitPrice(originalAmount.amount);
    const originalLineAmount = roundPayableAmount(quantity * unitPrice);

    if (!this.isApplicable(quantity, discount)) {
      return {
        ...originalAmount,
        amount: originalLineAmount,
        originalPrice: { ...originalAmount, amount: originalLineAmount },
        discountedPrice: { ...originalAmount, amount: originalLineAmount },
        discountFixedAmount: discount,
      };
    }

    const discountedUnitPrice = roundUnitPrice(unitPrice - discount.amount.amount);

    const discountedPrice: Amount = {
      currencyCode: originalAmount.currencyCode,
      amount: roundPayableAmount(quantity * discountedUnitPrice),
    };

    return {
      ...discountedPrice,
      originalPrice: { ...originalAmount, amount: originalLineAmount },
      discountedPrice,
      discountFixedAmount: discount,
    };
  }
}
